

































































































































































































































































































































































































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import Http from "front-component/Http";
import EventBus from "front-component/EventBus";
import _ from "lodash";
import {Request} from "@/modules/request/Request";
import RequestCommentRepository, {Comment} from "@/repositories/request/RequestCommentRepository";
import DownloadLink from "@/components/miscellaneous/DownloadLink.vue";
import * as Constants from "@/Constants";
import {requestDocumentTypes, requestStatus} from "@/Constants";
import FileRepository, {Document} from "@/repositories/FileRepository";
import {Getter} from "vuex-class";
import RequestRepository from "@/repositories/request/RequestRepository";
import {User} from "front-component/modules/User";
import moment from "moment";

const components = {
    DownloadLink
};

@Component({components})
export default class Documents extends Vue {
    @Prop(String) private requestUuid!: string;
    @Prop(Boolean) private fixedHeight!: boolean;
    @Prop(Boolean) private showToggleButtonVisibility!: boolean;
    @Prop({}) private request!: Request;
    @Prop(Boolean) private canEditRequest!: boolean;
    @Prop(Boolean) private showDocumentsList!: boolean;
    @Prop({type: Boolean, default: false}) private large!: boolean;
    @Prop(Boolean) private isDocumentsListDisplayed!: boolean;

    private documents: object[] = [];
    private commentary: string = "";
    private fileList: any[] = [];
    private loading: boolean = false;
    private loadingDocument: boolean = false;
    private optionsMediaCampaign: any[] = [];
    private documentType: string = "";
    private filterDocumentsType: string = "";
    private filterAuthor: string = "";
    private listComment: any = [];
    private mediaCampaignUuid: string = "";
    private documentUuid: string = "";
    private requestDocumentTypes = Constants.requestDocumentTypes;
    private documentToUpload: Array<{uuid: string, name: string, type: string }> = [];
    protected selectedDocuments: { [key: string]: string } = {};

    @Getter("hasFeature") public hasFeature!: (feature: string) => boolean;
    @Getter("getCurrentOwnerUuid") public ownerUuid!: string;
    @Getter("getUserDepartment") public userDepartment!: string;
    @Getter("isLocalMedia") public isLocalMedia!: boolean;
    @Getter("isDsi") public isDsi!: boolean;
    @Getter("getOwnerWorkflow") public getOwnerWorkflow!: (isClient: boolean) => any[];
    @Getter("getCurrentUser") public currentUser!: User;

    @Watch("listComment")
    private onListCommentChange() {
        this.$emit("count-documents", this.countDocuments);
    }

    @Watch("documentType")
    private scrollToBottom(newValue: string, oldValue: string) {
        if (!oldValue && newValue) {
            this.$emit("scroll-to-bottom");
        }
    }
    public get headers(): object {
        return Http.getBaseObject().getHeaders();
    }

    public get uploadDocument(): string {
        return FileRepository.getUploadUrl();
    }

    public get filterTypes(): string[] {
        const types = this.listComment.reduce((acc: Set<string>, comment: Comment) => {
            comment.documents.forEach((document: Document) => {
                if (this.isDsi || this.isLocalMedia) {
                    if (document.type === requestDocumentTypes.MCL) {
                        acc.add(document.type);
                    }
                }
                acc.add(document.type);
            });
            return acc;
        }, new Set<string>());

        return Array.from(types);
    }
    public get filteredComments() {
        return this.listComment.map((comment: Comment) => ({
            ...comment,
            documents: comment.documents.filter((document: Document) => this.shouldShowDocument(comment, document))
        }));
    }

    public get uniqueAuthors() {
        const authors = new Set();
        this.filteredComments.forEach((comment: Comment) => {
            if (comment.documents.length > 0) {
                authors.add(comment.createdBy.displayName);
            }
        });
        return Array.from(authors).sort((a, b) =>
            (a as string).toLowerCase().localeCompare((b as string).toLowerCase(), "fr", {ignorePunctuation: true}
            ));
    }

    public get countDocuments() {
        return this.listComment.reduce((count: number, comment: Comment) => count + comment.documents.length, 0);
    }

    private mounted(): void {
        this.loadRequestComments();
    }

    @Watch("requestUuid")
    private watchRequest() {
        this.listComment = [];
        this.fileList = [];
        this.commentary = "";
        this.documents = [];
        this.loadingDocument = false;
        this.documentType = "";
        this.documentUuid = "";
        this.loadRequestComments();
    }

    @Watch("documentType")
    private updateDocumentType() {
        this.documents = [];
        this.loadingDocument = false;
        this.documentUuid = "";
        this.fileList = [];
    }

    @Watch("isDocumentsListDisplayed")
    private updateListComment() {
        this.goToBottomMessages();
    }

    private loadRequestComments(): void {
        const params = {
            filters: {
                request: this.requestUuid,
            },
            fields: [
                "uuid",
                "commentary",
                "createdBy.displayName",
                "createdAt",
                "documents.uuid",
                "documents.clientOriginalFileName",
                "documents.createdAt",
                "documents.createdBy.displayName",
                "documents.link",
                "documents.type",
            ],
        };
        RequestCommentRepository.get(params).then((data: object) => {
            this.listComment = data;
            this.goToBottomMessages();
        });
    }

    // constraints
    public beforeFileUpload(file: any): boolean {
        let isValidFileSize = file.size / 1024 / 1024 < 20;
        if (requestDocumentTypes.MC === this.documentType || requestDocumentTypes.MCL === this.documentType) {
            isValidFileSize = file.size / 1024 / 1024 < 10;
        }

        const allFileTypes: any = Constants.fileType;

        if (!isValidFileSize) {
            EventBus.$emit("error-alert", _.invoke(this.$options.filters, "trans", "invalidFileSize"));
            return false;
        }

        const acceptedFileType = -1 !== _.findIndex(allFileTypes, (fileType: any) => {
            return fileType.type === file.type;
        });

        if (!acceptedFileType) {
            EventBus.$emit("error-alert", _.invoke(this.$options.filters, "trans", "invalidFileType"));
            return false;
        }

        return true;
    }

    public handleRemove(file: File, fileList: File[]) {
        const findIndex = _.findIndex(this.documents, (fileInList) => {
            return _.get(file, "uuid") === _.get(fileInList, "uuid");
        });
        this.$delete(this.documents, findIndex);
        this.documentUuid = "";
    }

    public handleSuccess(response: Response, file: File, fileList: File[]) {
        this.documents.push({uuid: _.get(response, "data.uuid"), name: file.name, type: this.documentType});
        if (this.requestDocumentTypes.MCL === this.documentType) {
            this.documentUuid = _.get(response, "data.uuid");
        }

        this.loadingDocument = false;
    }

    public handleError(err: Error, file: File, fileList: File[]) {
        EventBus.$emit("error-alert", _.invoke(this.$options.filters, "trans", "errorUploadFile"));
        this.loadingDocument = false;
    }

    public loadDocument(event: Event, file: File, fileList: File[]) {
        this.loadingDocument = true;
    }

    public get saveAllowed(): boolean {
        return !!(
            (
                this.requestDocumentTypes.MCL === this.documentType &&
                this.mediaCampaignUuid &&
                this.documentUuid
            ) || (
                this.requestDocumentTypes.MCL !== this.documentType
                &&
                (this.documents.length > 0 || this.commentary.length > 0)
            )
        );
    }

    public saveRequestComment(): void {
        if (this.mediaCampaignUuid && this.requestDocumentTypes.MCL === this.documentType) {
            this.saveRequestDocumentMediaCampaign();
        }

        const requestStatusNonClientStateMachine = this.getOwnerWorkflow(false);

        const requestComment = {
            request: {
                uuid: this.requestUuid,
            },
            commentary: this.commentary,
            documents: this.documents,
        };

        RequestCommentRepository.save(requestComment).then((data: object) => {
            if (
                requestStatus.onGoing === this.request.status &&
                this.documentType === requestDocumentTypes.MC &&
                _.has(requestStatusNonClientStateMachine, requestStatus.toValidate)
            ) {
                this.proposeNewStatus(requestStatus.toValidate);
            }
            if (
                [
                    requestStatus.validated,
                    requestStatus.goodForOrder,
                    requestStatus.partialPurchaseOrder,
                    requestStatus.processedPurchaseOrder,
                    requestStatus.completed
                ].includes(this.request.status) &&
                this.documentType === requestDocumentTypes.QUOTE &&
                _.has(requestStatusNonClientStateMachine, requestStatus.quoteCreated)
            ) {
                this.proposeNewStatus(requestStatus.quoteCreated);
            }
            if (
                requestStatus.quoteCreated === this.request.status &&
                this.documentType === requestDocumentTypes.BDC &&
                _.has(requestStatusNonClientStateMachine, requestStatus.goodForOrder)
            ) {
                this.proposeNewStatus(requestStatus.goodForOrder);
            }
            if (
                requestStatus.partialPurchaseOrder === this.request.status &&
                this.documentType === requestDocumentTypes.BDC &&
                _.has(requestStatusNonClientStateMachine, requestStatus.goodForOrder)
            ) {
                this.proposeNewStatus(requestStatus.goodForOrder);
            }
            if (
                requestStatus.completed !== this.request.status &&
                this.documentType === requestDocumentTypes.CAMPAIGN_REPORT
            ) {
                this.proposeNewStatus(requestStatus.completed);
            }

            this.loadRequestComments();
            this.fileList = [];
            this.commentary = "";
            this.documents = [];
            this.documentType = "";
        });
    }

    public saveRequestDocumentMediaCampaign(): void {
        const requestToSave = {
            uuid: this.request.uuid,
            requestDocumentMediaCampaigns: [{
                mediaCampaign: {
                    uuid: this.mediaCampaignUuid
                },
                document: {
                    uuid: this.documentUuid,
                },
            }
            ],
        };
        RequestRepository.save(requestToSave).then((data: any) => {
            this.request.requestDocumentMediaCampaigns.push(data.requestDocumentMediaCampaigns[0]);
            this.mediaCampaignUuid = "";
            this.documentUuid = "";
            if (requestStatus.onGoing === this.request.status) {
                this.proposeNewStatus(requestStatus.validated);
            }
        });
    }

    public proposeNewStatus(newStatus: string): void {
        this.$confirm(
            _.invoke(
                this.$options.filters,
                "trans",
                "updateStatusTo" + _.upperFirst(newStatus)
            ),
            {
                confirmButtonText: _.invoke(this.$options.filters, "trans", "yes"),
                cancelButtonText: _.invoke(this.$options.filters, "trans", "no"),
            }).then(() => this.saveStatus(newStatus)).catch(() => 0)
        ;
    }

    public toggleShowDocumentsList() {
        this.$emit("toggle-show-documents-list", !this.showDocumentsList);
    }

    public goToBottomMessages() {
        this.$nextTick(() => {
            const el = this.$refs.requestMessages as HTMLElement;
            if (el) {
                el.scrollTop = el.scrollHeight;
            }
        });
    }

    private saveStatus(newStatus: string): void {
        const newStatusSaveData = {
            uuid: this.requestUuid,
            status: newStatus,
        };

        const newStatusReturnParams = {
            fields: [
                "uuid",
                "status",
            ]
        };
        RequestRepository.save(newStatusSaveData, newStatusReturnParams).then((request) => {
            this.loading = false;
            this.$emit("update-status", newStatus);
            EventBus.$emit("request-status-updated", newStatus, this.requestUuid);
        });
    }

    private replaceURLTextWithHTMLLinks(text: string) {
        const exp = /(?:^|[^"'])(\b(?:https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
        return text.replace(exp, (match, url) => {
            const linkText = url.length > 50 ? url.substr(0, 50) + "..." : url;
            return " <a href=\"" + url + "\" target=\"_blank\" rel=\"noopener noreferrer\">" + linkText + "</a> ";
        });
    }

    private deleteDocument(requestComment: Comment): void {
        if (!confirm(_.invoke(this.$options.filters, "trans", "confirmDeleteDocument"))) {
            return;
        }

        requestComment.documents.forEach((document: Document) => {
            if (this.isChecked(document)) {
                this.$delete(this.selectedDocuments, document.uuid);
            }
        });

        moment.locale("fr");
        const commentary = this.commentary + "Document supprimé par [" + this.currentUser.displayName +
            "] le [" + moment().format("Do MMMM YYYY") + "]";

        const newRequestComment = {
            uuid: requestComment.uuid,
            commentary: _.invoke(this.$options.filters, "trans", commentary),
            documents: [],
        };

        RequestCommentRepository.save(newRequestComment).then((data: object) => {
            this.loadRequestComments();
        });
    }

    private shouldShowDocument(comment: Comment, document: Document) {
        const typeMatch = !this.filterDocumentsType || document.type === this.filterDocumentsType;
        const authorMatch = !this.filterAuthor || comment.createdBy.displayName === this.filterAuthor;
        return typeMatch && authorMatch;
    }

    private isChecked(document: Document): boolean {
        return _.has(this.selectedDocuments, document.uuid);
    }

    public updateSelected(document: Document, event: any): void {
        const uuid = document.uuid;
        if (event.target.checked) {
            this.$set(this.selectedDocuments, uuid, uuid);
        } else if (this.selectedDocuments[uuid]) {
            this.$delete(this.selectedDocuments, uuid);
        }
    }

    private selectAllRows(event: any): void {
        if (event.target.checked) {
            this.filteredComments.forEach((comment: Comment) => {
                comment.documents.forEach((document: Document) => {
                    this.$set(this.selectedDocuments, document.uuid, document.uuid);
                });
            });
        } else {
            this.selectedDocuments = {};
        }
    }

    public get exportDisabled(): boolean {
        return 0 === _.size(this.selectedDocuments) || this.loading;
    }

    public downloadDocuments(): void {
        const uri = "download_zip";
        const documentName = "request-comments-documents.zip";
        this.loading = true;
        Http.download(
            this.$router.resolve({name: uri}).href,
            {uuid: _.values(this.selectedDocuments)},
            (data: Blob) => {
                const url = window.URL.createObjectURL(data);
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", documentName);
                link.click();
                this.loading = false;
            },
            () => {
                this.loading = false;
                EventBus.$emit("error-alert", {message: "errorDownloadDocument"});
            }
        );
    }

    public get requestDocumentTypesOptions(): Array<{ value: string, label: string }> {
        const types = [
            {value: requestDocumentTypes.OTHER, label: "request_comment"},
            {value: requestDocumentTypes.CAMPAIGN_REPORT, label: "request_campaign_report"},
            {value: requestDocumentTypes.BDC, label: "request_bdc"},
            {value: requestDocumentTypes.BRIEF, label: "request_brief"},
            {value: requestDocumentTypes.CREA, label: "request_crea"},
            {value: requestDocumentTypes.QUOTE, label: "request_quote"},
            {value: requestDocumentTypes.SUPPLIER_QUOTE, label: "request_supplier_quote"},
            {value: requestDocumentTypes.TECHNICAL_MATRIX, label: "request_technical_matrix"},
            {value: requestDocumentTypes.ODP, label: "request_odp"},
            {value: requestDocumentTypes.MC, label: "request_mc"},
            {value: requestDocumentTypes.ACCOUNT_REPRINT, label: "request_account_reprint"},
        ];

        return types;
    }
}
